export default "__VITE_ASSET__DP8K65K7__"